import React from "react";
import { Link } from "react-router-dom";
import ArtistImages from "../components/ArtistImages/ArtistImages";
import "./Home.css";
import NatRamanImage from "../assets/portraits/NatRaman2.JPG";


const Home = () => {
  return (
    <main>
      {/* HERO SECTION */}
      <section className="hero-section">
        <h1 className="hero-heading">Welcome to Shrutilaya Fine Arts</h1>
        <p className="hero-subtext">Where Tradition Meets Melody – Learn, Explore, and Perform Carnatic Music.</p>
        <ArtistImages />
      </section>

      {/* ABOUT CARNATIC MUSIC */}
      <section className="info-section">
        <div className="page-section">
          <h2>About Carnatic Music</h2>
          <p>
            Carnatic music is one of the oldest and most intricate forms of classical music,
            rooted in the rich cultural heritage of South India. It is a deeply expressive 
            art form that blends melody (raga), rhythm (tala), and lyrical devotion to create 
            a spiritually enriching experience. Whether through soulful krithis, vibrant swaras, 
            or elaborate alapana, this tradition continues to inspire artists and audiences worldwide.
          </p>
        </div>
      </section>

      {/* MEET THE INSTRUCTOR */}
      <section className="meet-instructor">
        <div className="page-section">
          <h2>Meet Seattle Raman</h2>
          <div className="instructor-container">
            <div className="instructor-text">
              <p>
                Shri. Nat Raman, popularly known as Seattle Raman, has been passionately involved in promoting Carnatic music 
                for over 25 years. As a vocalist, educator, and mentor, he brings a wealth of experience to students of all ages.
              </p>
              <p>
                His teaching approach emphasizes melody, rhythm, and expression, ensuring students develop a deep appreciation 
                for the art while honing their technical skills.
              </p>
              <Link to="/about" className="cta-button">Learn More About Him</Link>
            </div>
            <div className="instructor-image">
            <img src={NatRamanImage} alt="Seattle Raman" />

            </div>
          </div>
        </div>
      </section>

      {/* COURSES OFFERED */}
      <section className="courses-section">
        <div className="page-section">
          <h2>Courses Offered</h2>
          <p>Explore our structured curriculum designed for beginners to advanced students.</p>
          <div className="courses-grid">
            <div className="course-card">
              <h3>Carnatic Basics</h3>
              <p>Introduction to Swaras, Geethams, Swarajathis, and basic Taalams.</p>
            </div>
            <div className="course-card">
              <h3>Intermediate & Advanced Training</h3>
              <p>Varnams, Kritis, Swara Improvisation, and Concert Preparation.</p>
            </div>
            <div className="course-card">
              <h3>Prayer Bhajans</h3>
              <p>Bhajans for devotional practice, suitable for all age groups.</p>
            </div>
            <div className="course-card">
              <h3>Pancharatna Kritis</h3>
              <p>Detailed study of Thyagaraja’s five masterpieces.</p>
            </div>
          </div>
          <Link to="/curriculum" className="cta-button">View Full Curriculum</Link>
        </div>
      </section>

      {/* CALL TO ACTION */}
      <section className="cta-section">
        <h2>Ready to Learn Carnatic Music?</h2>
        <p>Join Shrutilaya Fine Arts and immerse yourself in the timeless tradition of melody and rhythm.</p>
        <Link to="/contact" className="cta-button">Enroll Now</Link>
      </section>
    </main>
  );
};

export default Home;
